exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-main-breadcrumb{display:block}adp-main-breadcrumb .main-breadcrumb{color:#bdbdbd;font-size:28px}adp-main-breadcrumb .main-breadcrumb li{margin-left:15px}adp-main-breadcrumb .main-breadcrumb li:first-of-type,adp-main-breadcrumb .main-breadcrumb li:first-of-type span{margin-left:0}adp-main-breadcrumb .main-breadcrumb li:first-of-type i{display:none}adp-main-breadcrumb .main-breadcrumb li.current a,adp-main-breadcrumb .main-breadcrumb li.current i{opacity:1;color:#0e5061;cursor:pointer}adp-main-breadcrumb .main-breadcrumb li a{display:flex;align-items:center;padding:5px 0;opacity:.5;color:#6a6a6a}adp-main-breadcrumb .main-breadcrumb li span{display:inline-block;vertical-align:top;margin-left:15px}adp-main-breadcrumb .main-breadcrumb li i{opacity:.5;color:#6a6a6a;font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpMainBreadcrumb/adpMainBreadcrumb.less
// module id = 570
// module chunks = 0